import {
  handleFormType,
  handleFormCancle,
  fetchServiceLevelType,
  fetchServiceLocation,
  fetchContactServiceOfferingAddOn,
  fetchShipMethod,
  handleToast,
  setSelectedGrid,
  handelReset,
  handleResetGridSelection,
  perPageSizeSet,
  recordCountSet,
  fetchServicePriceLevel,
  fetchWorkOrderType,
  fetchServiceResponseType,
  handleAlertBoxOpen,
  handleCollpaseClick,
  fetchNoteType,
  fetchOosCasesReviewStatus,
  fetchCaseType,
  fetchChargeCode,
  handleSelectedTab,
  handleInnerSelectedTab,
  handleInnerOosSelectedTab,
  setReturnUrl,
  handleCollpaseOOSLevelClick,
  handleAlertBoxSave,
  fetchUserPermissions,
  userLoginActivity,
  getContractHistoryTypes,
  setPageRecordCount,
  setPageIndex,
} from './CommonSlice';
import useCustomDispatch from '../../hooks/useDispatch';

const CommonFacade = () => {
  const { customeDispatchFunction } = useCustomDispatch();

  // handle form type
  const setFormType = (payload) => {
    customeDispatchFunction(handleFormType(payload));
  };

  // handle form cancle
  const closeForm = (payload) => {
    customeDispatchFunction(handleFormCancle(payload));
  };

  // handle service level type
  const getServiceLevelType = () => {
    customeDispatchFunction(fetchServiceLevelType());
  };

  // handle service location
  const getServiceLocation = () => {
    customeDispatchFunction(fetchServiceLocation());
  };

  // handle contact service offering add on
  const getContactServiceOfferingAddOn = () => {
    customeDispatchFunction(fetchContactServiceOfferingAddOn());
  };

  // handle ship method
  const getShipMethod = () => {
    customeDispatchFunction(fetchShipMethod());
  };

  // handle toaster
  const handleToaster = (payload) => {
    customeDispatchFunction(handleToast(payload));
  };

  // handle selected grid
  const setSelected = (payload) => {
    customeDispatchFunction(setSelectedGrid(payload));
  };

  // handle reset common state
  const handleResetCommonState = () => {
    customeDispatchFunction(handelReset());
  };

  // handle reset grid selection
  const resetGridSelection = () => {
    customeDispatchFunction(handleResetGridSelection());
  };

  const setPerPageSize = (payload) => {
    customeDispatchFunction(perPageSizeSet(payload));
  };

  const setRecordCount = (payload) => {
    customeDispatchFunction(recordCountSet(payload));
  };

  // handle service price level
  const getServicePriceLevel = () => {
    customeDispatchFunction(fetchServicePriceLevel());
  };

  // handle work order type
  const getWorkOrderType = () => {
    customeDispatchFunction(fetchWorkOrderType());
  };

  // handle service response type
  const getServiceResponseType = () => {
    customeDispatchFunction(fetchServiceResponseType());
  };

  //common Alert
  const setAlertBoxOpen = (payload) => {
    customeDispatchFunction(handleAlertBoxOpen(payload));
  };
  // expend collepse
  const setCollepseable = (payload) => {
    customeDispatchFunction(handleCollpaseClick(payload));
  };

  // handle getNoteType type
  const getNoteType = () => {
    customeDispatchFunction(fetchNoteType());
  };

  // handle OOS Review Status type
  const getReviewStatus = () => {
    customeDispatchFunction(fetchOosCasesReviewStatus());
  };

  // handle OOS Case Type type
  const getCaseType = () => {
    customeDispatchFunction(fetchCaseType());
  };

  // handle OOS Case Type type
  const getChargeCode = () => {
    customeDispatchFunction(fetchChargeCode());
  };
  // handle selected tab value
  const setSelectedTabValue = (payload) => {
    customeDispatchFunction(handleSelectedTab(payload));
  };
  // handle selected tab value
  const setInnerSelectedTabValue = (payload) => {
    customeDispatchFunction(handleInnerSelectedTab(payload));
  };
  // handle selected tab value
  const setInnerOosSelectedTabValue = (payload) => {
    customeDispatchFunction(handleInnerOosSelectedTab(payload));
  };

  //Set Return URL
  const handleReturnUrl = (payload) => {
    customeDispatchFunction(setReturnUrl(payload));
  };

  // expend Contracts  OOS Level collepse
  const setCollepseableOOSLevel = (payload) => {
    customeDispatchFunction(handleCollpaseOOSLevelClick(payload));
  };

  //Out OF Scope Alert Bix Open and Close
  const setAlertBoxSave = (payload) => {
    customeDispatchFunction(handleAlertBoxSave(payload));
  };

  const getUserPermissions = (payload) => {
    customeDispatchFunction(fetchUserPermissions(payload));
  };

  const setUserLoginActivity = (payload) => {
    customeDispatchFunction(userLoginActivity(payload));
  };

  const fetchContractHistoryTypes = (payload) => {
    customeDispatchFunction(getContractHistoryTypes(payload));
  };

  // set Grid page record count
  const setGridPageRecordCount = (payload) => {
    customeDispatchFunction(setPageRecordCount(payload));
  };

  //set Grid page index
  const setGridPageIndex = (payload) => {
    customeDispatchFunction(setPageIndex(payload));
  };

  return {
    setFormType,
    closeForm,
    getServiceLevelType,
    getServiceLocation,
    getContactServiceOfferingAddOn,
    getShipMethod,
    handleToaster,
    setSelected,
    handleResetCommonState,
    resetGridSelection,
    setPerPageSize,
    setRecordCount,
    getServicePriceLevel,
    getWorkOrderType,
    getServiceResponseType,
    setAlertBoxOpen,
    setCollepseable,
    getNoteType,
    getReviewStatus,
    getCaseType,
    getChargeCode,
    setSelectedTabValue,
    setInnerSelectedTabValue,
    setInnerOosSelectedTabValue,
    handleReturnUrl,
    setCollepseableOOSLevel,
    setAlertBoxSave,
    getUserPermissions,
    setUserLoginActivity,
    fetchContractHistoryTypes,
    setGridPageRecordCount,
    setGridPageIndex,
  };
};

export default CommonFacade;
